import { render, staticRenderFns } from "./JobGeneral.vue?vue&type=template&id=0fa39392&"
import script from "./JobGeneral.vue?vue&type=script&lang=js&"
export * from "./JobGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports